<template>
    <window-portal :open="dataProps?.show" @close="() => {
        if (dataProps) {
            dataProps.show = false
            if (dataProps?.closeCallback) {
                dataProps?.closeCallback()
            };
        }
    }
        ">
        <div style="font-family: arial !important; margin-top: 10px; margin-bottom: 10px;">
            <center><div><p style="font-size: 30px;">Vista previa de impresión de Ticket 1</p></div></center>
            <br/>
            <center>
                <button class="btnclean" style="font-size: 18px;" @click="imprimirFacturaDirecta()">
                    Imprimir
                </button>
                &nbsp;&nbsp;
                <button class="btnclean" style="font-size: 18px;" @click="Download()">
                    Descargar
                </button>
                &nbsp;&nbsp;
                <button class="btnclean" style="font-size: 18px;" @click="sendMail()">
                    Enviar Correo
                </button>
                &nbsp;&nbsp;
                <button class="btnclean" style="font-size: 18px;" @click="downLoadJSON()">
                    Descargar JSON
                </button>
            </center>
            <center><div v-if="loading"><p>Cargando...</p></div></center>

        </div>
        <div style="font-family: arial !important; margin-top: 10px; margin-bottom: 10px;">
            <center v-if="mailLabel">
                {{ mailLabel }}
            </center>
        </div>

        <div class="book" style="margin: 0; padding: 0; background-color: rgb(105, 105, 105); font-family: arial !important; padding-top: 20px; padding-bottom: 20px;">
                <div style="margin: 0 auto; width: 400px;display: flex;
                                 justify-content: center; font-size: 10pt;">
                    <div v-if="hasPrintableData" ref="dataprint" style="margin: 0 !important; padding: 0 !important;">
                        <!--div style="position: relative; width: 1000px; min-height: 1294px; background: white;"-->
                      
                            <div style="position: relative; width: 325px;  background: white;">
                            
                                <div style="margin: 20px">
                                <div  style="display: flex; justify-content: center; margin-top: 1rem">
                                    
                                    <div style="margin: 20px"> 
                                        {{dataProps.data.user?.business}}
                                    </div>
                                </div>
                                <div style="text-align: center; vertical-align: middle; width: 100%">          
                                    <img
                                        v-if="dataProps.data.branch?.BranchLogoPath != null && dataProps.data.branch?.BranchLogoPath != '' && dataProps.data.branch?.BranchLogoPath != 'null'"
                                        style="max-width: 200px; height: 50px"
                                        :src="dataProps.data.branch.BranchLogoPath"
                                        crossorigin="anonymous"
                                    />        
                                </div>
                                <div
                                    v-if="hasText(dataProps.data.branch?.BusinessBillingName)"
                                    style="text-align: center; vertical-align: middle; width: 100%; font-size: 9pt;"
                                >
                                    RAZÓN SOCIAL: {{ formatText(dataProps.data.branch?.BusinessBillingName) }}
                                </div>
                                <div
                                    v-if="hasText(dataProps.data.header?.EmisorDescActividad)"
                                    style="text-align: center; vertical-align: middle; width: 100%; font-size: 9pt;"
                                >
                                    ACTIVIDAD: {{ formatText(dataProps.data.header?.EmisorDescActividad) }}
                                </div>
                                <div
                                    v-if="hasText(dataProps.data.branch?.BranchLegalAddress)"
                                    style="text-align: center; vertical-align: middle; width: 100%; font-size: 9pt;"
                                >
                                    DIRECCIÓN: {{ formatText(dataProps.data.branch?.BranchLegalAddress) }}
                                </div>
                                <div
                                    v-if="hasText(dataProps.data.branch?.BranchPhone)"
                                    style="text-align: center; vertical-align: middle; width: 100%; font-size: 9pt;"
                                >
                                    TÉLEFONO: {{ dataProps.data.branch?.BranchPhone }}
                                </div>
                                <div
                                    v-if="hasText(dataProps.data.branch?.BranchMobile)"
                                    style="text-align: center; vertical-align: middle; width: 100%; font-size: 9pt;"
                                >
                                    WHATSAPP: {{ dataProps.data.branch?.BranchMobile }}
                                </div>
                                <div
                                    v-if="hasText(dataProps.data.branch?.BranchEmail)"
                                    style="text-align: center; vertical-align: middle; width: 100%; font-size: 9pt;"
                                >
                                    E-MAIL: {{ formatText(dataProps.data.branch?.BranchEmail) }}
                                </div>
                                <div
                                    v-if="hasText(dataProps.data.branch?.BusinessBillingNIT)"
                                    style="text-align: center; vertical-align: middle; width: 100%; font-size: 9pt;"
                                >
                                    NIT: {{ formatText(dataProps.data.branch?.BusinessBillingNIT) }}
                                </div>
                                <div
                                    v-if="hasText(dataProps.data.branch?.BusinessBillingNRC)"
                                    style="text-align: center; vertical-align: middle; width: 100%; font-size: 9pt;"
                                >
                                    NRC: {{ formatText(dataProps.data.branch?.BusinessBillingNRC) }}
                                </div>
                                <hr />
                                <table style="border-collapse: collapse; font-size: 9pt; width: 100%; vertical-align: top">
                                    <tr>
                                        <div style="display: flex; justify-content: space-between; margin: 0px 5px">
                                            <span>Fecha emisión: {{ dataProps.data.header.InvoiceDate }}</span>
                                            <span>Hora: {{ timeEmisionFac }}</span>
                                        </div>
                                    </tr>
                                    <br />
                                </table>
                                <div style="display: flex; justify-content: center; margin-top: .2rem">
                                    <div>
                                        <b>Correlativo:</b>
                                        {{dataProps.data.header.ID_Invoice}}
                                    </div>
                                </div>
                                <div  style="display: flex; justify-content: center; margin-top: .2rem">
                                    <div>
                                        <div> 
                                            <b>Vendedor </b>
                                            {{dataProps.data.user.business}}
                                        </div>
                                    </div>
                                </div>
                                <br />
                                <hr />
                                <div v-for="(item, index) in dataProps.data.body" :key="index" style="margin-top: .2rem">
                                   
                                   <div style="margin-left:.5rem">
                                    {{ item.ID_Item  + ' ' + item.ItemName }}{{ getLote(item) }}
                                   </div>
                                   <div  style="margin-left:.8rem">
                                    {{ item.ItemQuantity + ' X '  + numberWithCommas(parseFloat(item.ItemUnitPrice).toFixed(2)) + ' = ' +  numberWithCommas(parseFloat(item.ItemGravada).toFixed(2)) }}
                                   </div>
                                   
                                </div>
                                <div style="margin-top:1rem; margin-left:.5rem; display:flex">
                                    Sub total 
                                    <div style="margin-left:7rem">
                                        {{dataProps.data.header.InvoiceCurrency}}
                                        {{numberWithCommas(parseFloat(dataProps.data.header.InvoiceSubTotalVentas).toFixed(2))}}
                                    </div>
                                </div>
                                <!--div style="margin-top:.2rem; margin-left:.5rem; display:flex">
                                    Ventas no sujetas
                                    <div style="margin-left:3.7rem">
                                        {{dataProps.data.header.InvoiceCurrency}}
                                        {{numberWithCommas(parseFloat(dataProps.data.header.InvoiceDescuNoSuj).toFixed(2))}}
                                    </div>
                                </div-->
                                <!--div style="margin-top:.2rem; margin-left:.5rem; display:flex">
                                    Ventas exentas
                                    <div style="margin-left:4.6rem">
                                        {{dataProps.data.header.InvoiceCurrency}}
                                        {{numberWithCommas(parseFloat(dataProps.data.header.InvoiceDescuExenta).toFixed(2))}}
                                    </div>
                                </div-->
                                <!--div style="margin-top:.2rem; margin-left:.5rem; display:flex">
                                    Ventas gravadas
                                    <div style="margin-left:4.1rem">
                                        {{dataProps.data.header.InvoiceCurrency}}
                                        {{numberWithCommas(parseFloat(dataProps.data.header.InvoiceDescuGravada).toFixed(2))}}
                                    </div>
                                </div-->
                                <div style="font-size: 14px;margin-top:.2rem; margin-left:.5rem; display:flex">
                                    <b>Total</b>
                                    <div style="margin-left:8.6rem">
                                        <b>{{dataProps.data.header.InvoiceCurrency}}</b>
                                        <b>{{numberWithCommas(parseFloat(dataProps.data.header.InvoiceTotalPagar).toFixed(2))}}</b>
                                    </div>
                                </div>
                                <GuaranteePrintBlock
                                    v-if="hasGuarantee"
                                    :html="dataProps.guaranteeHtml"
                                    :business-id="guaranteeBusinessId"
                                    :branch-id="guaranteeBranchId"
                                    guarantee-type="TICKET"
                                    font-size="10px"
                                    style="margin-top: 12px; padding-left: 12px; padding-right: 12px; box-sizing: border-box;"
                                />
                                <!-- espacio en blanco al finalizar factura de ticket -->
                                <div>&nbsp;</div>
                                <div>&nbsp;</div>
                                <div>&nbsp;</div>
                                <div>&nbsp;</div>
                                <div>&nbsp;</div>
                                <div>&nbsp;</div>
                                <div style="min-height:200px; border-bottom: 1px dotted black; border-width: 2px;">&nbsp;</div>
                                </div>
                            </div>
                            
                    </div>
                    <div v-else style="color: white; padding: 20px 0;">
                        Cargando vista previa...
                    </div>
                <div>
    
    
   
    
</div>



                  
                    </div>
        </div>
    </window-portal>
</template>

<script>

import jsPDF from "jspdf"
import QRCode from 'qrcode';
//import html2canvas from "html2canvas"
import WindowPortal from "@/components/ReportsAndPrintings/WindowPortal.vue"
import GuaranteePrintBlock from "@/components/ReportsAndPrintings/GuaranteePrintBlock.vue";
import { addFormatToNIT, addFormatNRC } from "../../helpers/misc"
import { numberWithCommas } from "../../helpers/money";
import {numberToText} from '@/helpers/conveterNumberText.js'
import moment from 'moment';
import { imprimirFactura } from "../../utils/printInvoice";

export default {
    name: "PrintPosTk",
    props: ['dataProps'],
    components: {WindowPortal, GuaranteePrintBlock},
    data() {
        return {
            header: null,
            footer: null,
            loading: false,
            //seal: "",
            //sealBranch: "",
            numPages: 0,
            //valuesRows: []
            mailLabel: null,
            valuesRows: [],
            urlQr: null,
            typePrint: 0,
            keymaster: JSON.parse(localStorage.getItem('user'))?.keymaster ?? '',
        }
    },
    mounted() {
        //console.log(this.dataProps);
        //console.log(this.dataProps.data.branch)
        //console.log(this.dataProps.data.dteJson)
        //this.seal = JSON.parse(localStorage.getItem("user")).seal || ""
        //this.sealBranch = JSON.parse(localStorage.getItem("user")).sealBranch || ""
      //  this.getHeaderFooter()
        // if(this.dataProps.)
        // this.$nextTick(() => {
        //     this.sendMail();
        // })
    },
    computed: {
        /*edad() {
            let edad = this.dataProps.data.profile.Age
            if (edad == null || edad == undefined) {
                return ''
            } else {
                return edad
            }
        },*/
        BillingNrc() {
            return this.dataProps?.data?.branch?.BusinessBillingNRC
                ? addFormatNRC(this.dataProps.data.branch.BusinessBillingNRC)
                : '';
        },
        BillingNit() {
            return this.dataProps?.data?.branch?.BusinessBillingNIT
                ? addFormatToNIT(this.dataProps.data.branch.BusinessBillingNIT)
                : '';
        },
        guaranteeBusinessId() {
            return (
                this.dataProps?.businessId ||
                this.dataProps?.data?.branch?.ID_Business ||
                JSON.parse(localStorage.getItem("user"))?.businessid ||
                null
            );
        },
        guaranteeBranchId() {
            return (
                this.dataProps?.branchId ||
                this.dataProps?.data?.branch?.ID_Branch ||
                JSON.parse(localStorage.getItem("branch"))?.ID_Branch ||
                null
            );
        },
        hasGuarantee() {
            return Boolean(String(this.dataProps?.guaranteeHtml || "").trim()) || Boolean(this.guaranteeBusinessId);
        },
        timeEmisionFac(){
            if (!this.hasPrintableData) {
                return '';
            }
            const fechaCompleta = moment(this.dataProps.data.header.SystemDateUpdate);
            const soloHora = fechaCompleta.format("HH:mm:ss");
            return soloHora
        },
        hasPrintableData() {
            return !!(
                this.dataProps &&
                this.dataProps.data &&
                this.dataProps.data.header &&
                this.dataProps.data.branch &&
                this.dataProps.data.user &&
                this.dataProps.data.body
            );
        },
        showLote(){
            return ['689510125c294fa0c2b02d6200cceb7f'].includes(this.keymaster)
        }
     
    },
    watch: {
        'dataProps.show'() {
            if(this.dataProps.show && this.hasPrintableData){
                this.loadPreviewAssets();
            }
        },
        hasPrintableData(newValue) {
            if (newValue && this.dataProps?.show) {
                this.loadPreviewAssets();
            }
        }
    },
    methods: {
        async imprimirFacturaDirecta(){
            this.loading = true;
            try {
                // console.log('this.dataProps', this.dataProps);
                const { data: { header: { ID_Invoice } } } = this.dataProps;
                // console.log('ID_Invoice', ID_Invoice);
                await imprimirFactura(ID_Invoice, this);
            } catch (error) {
                console.error('Error al imprimir factura:', error);
                // this.showAlert(
                // "danger",
                // "Error",
                // "Ha ocurrido un error al imprimir la factura"
                // );
            } finally {
                this.loading = false;
            }
        },
        hasText(value) {
            return value !== undefined && value !== null && String(value).trim() !== '' && String(value).trim().toLowerCase() !== 'null';
        },
        formatText(value) {
            return this.hasText(value) ? String(value).toUpperCase() : '';
        },
        loadPreviewAssets() {
            setTimeout(async () => {
                if (!this.hasPrintableData) {
                    return;
                }

                await this.calculatePagesOfDoc();
                const partes = this.dataProps.data.header.InvoiceDate.split("/");
                const dia = partes[0];
                const mes = partes[1];
                const anio = partes[2];

                // Crear una nueva fecha en formato "yyyy-mm-dd"
                const fechaNueva = `${anio}-${mes}-${dia}`;
                const url = this.dataProps.data.branch.AuthFeMode == 1
                    ? `https://admin.factura.gob.sv/consultaPublica?ambiente=01&codGen=${this.dataProps.data.header.CodigoGeneracion}&fechaEmi=${fechaNueva}`
                    : `https://admin.factura.gob.sv/consultaPublica?ambiente=00&codGen=${this.dataProps.data.header.CodigoGeneracion}&fechaEmi=${fechaNueva}`;

                const opt = {
                    errorCorrectionLevel: 'H',
                    type: 'image/png',
                    quality: 0.3,
                    margin: 1,
                    color: {
                        dark: "#000000",
                        light: "#ffffff"
                    },
                    width: 100
                };

                QRCode.toDataURL(url, opt, (error, url) => {
                    if (error) {
                        console.log('Error al generar el código QR:', error);
                        throw error;
                    }

                    this.urlQr = url;
                });

                await this.getImages();
            }, 0);
        },
        getLote(item){
            if(this.showLote && item && item?.ID_ItemBatch?.length > 0) return ` - LOTE: ${item.ID_ItemBatch}`;
            return '';
        },
        GetnumberToText(number) {
            if(number) return numberToText(number)
            else return ''
        },
        numberWithCommas(x) {
            return numberWithCommas(x);
        },
        getHeaderFooter() {
            let search = {};
            search.ID_business = JSON.parse(localStorage.getItem("user")).businessid || ""
            search.ID_branch = JSON.parse(localStorage.getItem("user")).branch || ""
            this.$API.HF.getHF(search).then((data) => {
                let header = [], footer = [];
                header = data.filter((x) => x.State == '1' && x.Type == 'Header');
                this.header = header.length > 0 ? JSON.parse(header[0].Body).html : '';
                this.header = this.header.replace(/(\n)/gm, "");
                footer = data.filter((x) => x.State == '1' && x.Type == 'Footer');
                this.footer = footer.length > 0 ? JSON.parse(footer[0].Body).html : '';
            })
        },

        calculatePagesOfDoc() {
            if (!this.hasPrintableData) {
                return;
            }
            let pages = 0
            let rows = 0
            this.valuesRows[pages] = []

            try{
                if(this.dataProps.data.branch.BusinessBillingNRC == '3213715' || this.dataProps.data.branch.BusinessBillingNRC == '2201050') {
                    this.typePrint = 1
                    //One page
                    if(this.dataProps.data.body.length <= 24){
                        for(let i = 0; i < this.dataProps.data.body.length; i++){
                            rows++
                            this.valuesRows[pages].push(this.dataProps.data.body[i])
                        }    
                    }
                    else{
                        for(let i = 0; i < this.dataProps.data.body.length; i++){
                            if(rows < 29 && (i !== this.dataProps.data.body.length - 1)){
                                rows++
                                this.valuesRows[pages].push(this.dataProps.data.body[i])
                            }
                            else if(rows <= 24){
                                rows++
                                this.valuesRows[pages].push(this.dataProps.data.body[i])
                            }
                            else{
                                this.valuesRows[pages].push(this.dataProps.data.body[i])
                                pages++
                                rows = 0
                                this.valuesRows[pages] = []
                            }
                        }
                    }
                }
                else{
                    this.typePrint = 0
                    //Cuando es solo una página
                    if(this.dataProps.data.body.length <= 34){
                        for(let i = 0; i < this.dataProps.data.body.length; i++){
                            rows++
                            this.valuesRows[pages].push(this.dataProps.data.body[i])
                        }    
                    }
                    else{
                        for(let i = 0; i < this.dataProps.data.body.length; i++){
                            if(rows < 39 && (i !== this.dataProps.data.body.length - 1)){
                                rows++
                                this.valuesRows[pages].push(this.dataProps.data.body[i])
                            }
                            else if(rows <= 34){
                                rows++
                                this.valuesRows[pages].push(this.dataProps.data.body[i])
                            }
                            else{
                                this.valuesRows[pages].push(this.dataProps.data.body[i])
                                pages++
                                rows = 0
                                this.valuesRows[pages] = []
                            }
                        }
                    }
                }
                
            }
            catch(err) {
                alert(err)
            }
            pages = pages + 1
            this.numPages = pages
        },

        async Print(){
            if (!this.hasPrintableData) {
                return;
            }
            this.loading = true
            var doc = new jsPDF('p', 'pt', 'letter')

            await doc.html(this.$refs.dataprint, {
                callback: function(doc){
                    doc.output()
                },
                x: 0,
                y: 0,
                margin: [0, 0, 0, 0],
                html2canvas:{ 
                    scale: 1,
                    //scale: (doc.internal.pageSize.width - 10 * 2) / this.$refs.dataprint.scrollWidth,
                    useCORS: true,
                    logging: false,
                    allowTaint: true
                },
            })
            
            
            //doc.deletePage(2)

            doc.autoPrint({variant: 'non-conform'});
            const blob = doc.output("bloburl")
            window.open(blob)

            this.loading = false
        },

        async Download(){
            if (!this.hasPrintableData) {
                return;
            }
            this.loading = true
            var doc = new jsPDF('p', 'mm', [270, 841.89]);
            await doc.html(this.$refs.dataprint, {
                callback: function(doc){
                    doc.output()
                },
                x: 0,
                y: 0,
                margin: [0, 0, 0, 0],
                html2canvas:{ 
                    scale: 1,
                    //scale: (doc.internal.pageSize.width - 10 * 2) / this.$refs.dataprint.scrollWidth,
                    useCORS: true,
                    logging: false,
                    allowTaint: true
                },
            });
            
            //doc.deletePage(2)
        doc.save(this.dataProps.data.header.ID_Invoice+ "_"+this.dataProps.data.header.InvoiceDate.replaceAll("/","-") + "_"+this.dataProps.data.header.InvoiceName.replaceAll(/[:/<>*|/]/g, "").replaceAll('\\"','')+ ".pdf"); //Agregado por Juan 13082023

            this.loading = false
        },
        async sendMail() {
            try {
                if (!this.hasPrintableData) {
                    return;
                }
                this.mailLabel = null;
                var doc = new jsPDF('p', 'pt', 'letter')
                //console.log(doc);
                //console.log(this.$refs.dataprint);
                await doc.html(this.$refs.dataprint, {
                    callback: function(doc){
                        doc.output()
                    },
                    x: 0,
                    y: 0,
                    margin: [0, 0, 0, 0],
                    html2canvas:{ 
                        scale: 0.612,
                        //scale: (doc.internal.pageSize.width - 10 * 2) / this.$refs.dataprint.scrollWidth,
                        useCORS: true,
                        logging: false,
                        allowTaint: true
                    },
                });
                
                this.assignCuerpoDocumento();

                const { data: { header: { jsonMH }, dteJson: { ID_Invoice } } } = this.dataProps;

                const body = {
                    dtefilebuffer: new Buffer.from(doc.output('arraybuffer')),
                    dtejson: { ...jsonMH, ID_Invoice },
                    dtefilebufferfilename: this.dataProps.data.header.ID_Invoice+ "_"+this.dataProps.data.header.InvoiceDate.replaceAll("/","-") + "_"+this.dataProps.data.header.InvoiceName.replaceAll(/[:/<>*|/]/g, "").replaceAll('\\"','')
                };

                // console.log(body);
                this.$API.invoices.sendInvoiceMail(body);

                this.mailLabel = 'Se envió el correo correctamente';
                this.$emit('mailSent');
            } catch (error) {
                this.mailLabel = 'Ocurrió un error al enviar el correo';
                console.log(error);
            }
        },
        assignCuerpoDocumento() {
            this.dataProps.data.header.jsonMH.cuerpoDocumento = this.dataProps.data.body.map( ( item, index ) => ( {
                "descripcion": item.ItemDescription,
                "montoDescu": item.ItemDiscount,
                "codigo": item.ID_Item,
                "ventaGravada": item.ItemGravada,
                "ivaItem": item.ItemIva,
                "ventaNoSuj": item.ItemNoSuj,
                "ventaExenta": item.ItemExenta,
                // "tributos": null,
                "numItem": index + 1,
                "noGravado": item.ItemNoGravada,
                "psv": item.ItemPsv,
                // "tipoItem": 3,
                // "codTributo": null,
                "uniMedida": item.ItemMeasureUnit,
                // "numeroDocumento": null,
                "cantidad": item.ItemQuantity,
                "precioUni": item.ItemUnitPrice
            } ) )
            // for( const item in this.dataProps.data.body ) {
            //      [
            //         "descr"
            //     ]
            // }
        },
        async downLoadJSON() {
            try {
                if (!this.hasPrintableData) {
                    return;
                }
                const selloRecibido = JSON.parse(this.dataProps.data.header.ResponseMhJson).selloRecibido;
                const firmaElectronica = this.dataProps.data.header.JsonMhSigned.documento;
                const jsonToSend = { ...this.dataProps.data.header.JsonMh.dteJson , firmaElectronica , selloRecibido };
                delete jsonToSend.passwordPri;

                const aElement = document.createElement('a');
                aElement.setAttribute('download', this.dataProps.data.header.ID_Invoice+ "_"+this.dataProps.data.header.InvoiceDate.replaceAll("/","-") + "_"+this.dataProps.data.header.InvoiceName.replaceAll(/[:/<>*|/]/g, "").replaceAll('\\"','')+ ".pdf");
                this.assignCuerpoDocumento();
                const blob = new Blob([JSON.stringify(jsonToSend)], { type: 'application/json' });
                const href = URL.createObjectURL(blob);
                aElement.href = href;
                aElement.download = this.dataProps.data.header.ID_Invoice+ "_"+this.dataProps.data.header.InvoiceDate.replaceAll("/","-") + "_"+this.dataProps.data.header.InvoiceName.replaceAll(/[:/<>*|/]/g, "").replaceAll('\\"','')+ ".json";
                aElement.click();
                URL.revokeObjectURL(href);
            } catch (error) {
                this.mailLabel = 'Ocurrió un error al descargar JSON';
                console.log(error);
            }
        },
        async getImages() {
            try {
                if (!this.hasPrintableData) {
                    return;
                }
                const logo = this.dataProps.data.branch.BranchLogoPath;

                if (logo) {
                    const LogoBranchBase64 = localStorage.getItem("LogoBranchBase64")

                    if (LogoBranchBase64) {
                        this.dataProps.data.branch.BranchLogoPath = `${LogoBranchBase64}`;
                    }
                    else {
                        const { imageBase64: logoImageBase64 } = await this.$API.utilities.getImageInBase64({ file: logo });
                        this.dataProps.data.branch.BranchLogoPath = `${logoImageBase64}`;
                    }
                }

            } catch (error) {
                console.error('Error al cargar la imagen:', error);
                // Mantener la URL original si hay error
            }
        },
    }
}
</script>

<style scoped>
    .u-row .u-col-100{
        width: 100% !important;
    }
    .btnclean{
        border-radius: 15px;
        border: 1px solid white;
  background-color: #F29D35 !important;
  color: white !important;
}
    .btnclose{
        border-radius: 15px;
        border: 1px solid white;
        background-color: rgb(255, 38, 38) !important;
        color: white !important;
       
    }

    * {
        font-family: Arial, Helvetica, sans-serif !important;
    }

 

</style>
